/*
 * Google Identity Services: el botón "Entrar con Google".
 *
 * El script se carga solo cuando la pantalla de entrada lo pide, no en index.html:
 * con sesión abierta no hace falta, y así la app no depende de Google para arrancar.
 * Google entrega un ID token (JWT); quien lo valida es la API, nunca el navegador.
 */

type RespuestaGoogle = { credential: string };

type GoogleId = {
  accounts: {
    id: {
      initialize(o: { client_id: string; callback: (r: RespuestaGoogle) => void; auto_select?: boolean; ux_mode?: "popup" | "redirect" }): void;
      renderButton(el: HTMLElement, o: Record<string, string | number>): void;
      disableAutoSelect(): void;
    };
  };
};

declare global {
  interface Window {
    google?: GoogleId;
  }
}

let cargando: Promise<GoogleId> | null = null;

export function cargarGoogle(): Promise<GoogleId> {
  if (window.google) return Promise.resolve(window.google);
  cargando ??= new Promise<GoogleId>((ok, falla) => {
    const s = document.createElement("script");
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true;
    s.onload = () => (window.google ? ok(window.google) : falla(new Error("Google no se cargó")));
    s.onerror = () => { cargando = null; falla(new Error("Google no se cargó")); };
    document.head.appendChild(s);
  });
  return cargando;
}
